// Module
var code = "<ng-form> <div class=\"form-group form-field-type-jsoneditor\"> <label for=\"validateRules\" kform-builder-tooltip=\"Rules\">Rules</label> <div class=\"form-control\" ng-jsoneditor id=\"validateRules\" ng-model=\"component.validate.rules\"></div> </div> </ng-form> ";
// Exports
export default code;